<template>
  <v-card dark class="book-card-carousel w-100">
    <v-row class="px-4 py-4 ma-0 flex-nowrap carousel-wrap">
        <v-col cols="auto" class="pl-0 py-0">
          <div class="cover-img w-100">
            <v-img
                class="rounded"
                :height="$vuetify.breakpoint.md ? '205' : '160'"
                :width="$vuetify.breakpoint.md ? '150' : '125'"
                @click="$router.push(`/user/book/${id}`)"
                :src="`https://assets.beeverso.org/lbr/image/${imgSource}/cover_small.jpg`"
            ></v-img>
          </div>
        </v-col>
        <v-col cols="auto" class="py-0 pr-0 text-left flex-fill">
          <v-row class="ma-0">
            <span class="book-tag mb-2">{{ tag }}</span>
          </v-row>
          <h4 class="mb-2">{{ title }}</h4>
          <div class="d-block d-md-none">
            <p class="mb-1 truncate-overflow">{{ description }}</p>
          </div>
          <div class="progress-bar mb-1" ref="tooltipParent">
            <label for="">{{ $t('home.your_progress') }}</label>
            <div class="progress-bar__container">
              <v-progress-linear
                background-color="#514585"
                color="#C4BBE7"
                :value="completedTasksPercentage"
                height="15"
                rounded
              >
                <strong>{{ completedTasks }} de {{ totalTasks }} {{ $t('home.pages') }}</strong>
              </v-progress-linear>
            </div>
          </div>
          <div class="d-none d-sm-block mt-4">
            <v-btn
              outlined
              color="white"
              class="border-radius-1 text-transform-none"
              @click="$router.push(`/user/book/${id}`)"
            >
              <v-img
              :src="require('@/assets/img/icons/book-read.svg')"
              width="20"
              height="18"
              class="mr-2"
              ></v-img>
              {{ $t('home.continuous_reading') }}
            </v-btn>
          </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  data: () => ({
      showTooltip: false,
      treasure: require('@/assets/img/icons/treasure-stroke.png'),
      claimReward: require('@/assets/img/icons/claim-reward.png'),
      beecoinsIcon: require('@/assets/img/icons/beecoins.png'),
      rewards: true,

      showTooltip: false,
      attachToParent: false
    }),
  props: [ 'id', 'imgSource', 'title', 'description', 'endDate', 'tag', 'completedTasks', 'totalTasks' ],
  computed: {
    completedTasksPercentage() {
      return (this.completedTasks / this.totalTasks) * 100;
    }
  },
}
</script>

<style lang="scss" scoped>

.book-card-carousel{
  background: rgba($color: #ffffff, $alpha: .1);
  border: none;
  border-radius: 12px;
  min-height: 250px;
  padding: 1em;
  @media screen and (max-width: 1366px) {
      min-height: 265px;
  }
  @media screen and (max-width: 1263px) {
      min-height: 270px;
  }
  @media screen and (max-width: 959px) {
      min-height: 250px;
    }
    @media screen and (max-width: 767px) {
      min-height: 235px;
    }
  h4{
    line-height: 110%;
    // @media screen and (min-width: 960px) {
    //     min-height: 2em;
    // }
  }
  p{
    font-size: .8rem;
    line-height: 120%;
  }
  @media screen and (max-width: 959px) {
    background: linear-gradient(310.15deg, #A295DA -3.77%, #7764CA 29.51%, #6857B2 65.63%, #514585 93.49%);
    padding: 4px;
  }
}
.cover-img{
    align-items: center;
    display: flex;
    justify-content: center;
    min-height: 120px;
    &.empty{
        background: linear-gradient(147.2deg, #A295DA 4.28%, #7764CA 33.93%, #6857B2 62.04%, #514585 95.25%);
        border: 2px dashed #EEECF8;
        border-radius: 1em;
    }
    .v-btn{
        background: #EEECF8;
        box-shadow: inset 0px 0px 4px rgba(73, 60, 130, 0.5);
        .v-icon{
            background: linear-gradient(147.2deg, #A295DA 4.28%, #7764CA 33.93%, #6857B2 62.04%, #514585 95.25%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }

}

</style>
